import { get } from "../utilities/ajax";

export default class ArchiveAppend {

  constructor() {
    this.isFetching = false;
    this.setupEventHandlers();
  }

  /**
   * Setup event handlers for 'Load More' button clicks and 'Infinite Scroll'.
   * These events will dynamically determine the correct pagination element and its data.
   */
  setupEventHandlers() {
    jQuery(document.body).on('click', 'button.nav-link', this.handleTabChange.bind(this));
    jQuery(document.body).on("click", "#css_prefix_post_load_more", this.loadMore.bind(this));
    jQuery(window).on("scroll", this.handleScroll.bind(this));
  }

  /**
   * Handles tab change events. Resets the current page data attribute for the newly active tab's
   * pagination element (if any) to ensure loading starts from page 1 when switching tabs.
   *
   * @param {Event} e - The click event object.
   */
  handleTabChange(e) {
    const targetTabContentId = jQuery(e.target).attr('data-bs-target');
    const activeTabContent = jQuery(targetTabContentId);
    const loadMoreButton = activeTabContent.find('#css_prefix_post_load_more');
    const loader = activeTabContent.find('#css_prefix_loader-wheel-container');

    if (loadMoreButton.length > 0) {
      loadMoreButton.text(loadMoreButton.data('original-text'));
      loadMoreButton.prop('disabled', false);
      loadMoreButton.show();
    } else if (loader.length > 0) {
      loader.css("display", "none");
    }
  }

  /**
   * Handle infinite scroll by checking if the user has reached the bottom of the page.
   * It dynamically identifies the correct loader element to trigger `loadMore`.
   */
  handleScroll() {
    if (this.isFetching) return;

    let loader = jQuery(".tab-pane.active #css_prefix_loader-wheel-container");
    loader = loader.length ? loader : jQuery("#css_prefix_loader-wheel-container");

    if (!loader.length) return;

    const scrollTop = jQuery(window).scrollTop();
    const windowHeight = jQuery(window).height();
    const documentHeight = jQuery(document).height();

    if (scrollTop + windowHeight >= documentHeight - 100) {
      loader.css("display", "block");
      this.loadMore(null, loader);
    }
  }

  /**
   * Load more content, triggered by button click or infinite scroll.
   * It dynamically identifies the correct pagination element and extracts its data attributes.
   *
   * @param {Event} [event] - The event object from button click (optional).
   * @param {jQuery} [triggeringElement] - The specific jQuery element (button or loader) that triggered the load (optional, used by handleScroll).
   */
  loadMore(event, triggeringElement = null) {
    if (event) event.preventDefault();

    if (this.isFetching) return;

    this.isFetching = true;

    let currentElement; 
    let currentListingElement; 

    if (triggeringElement) {
      currentElement = triggeringElement;
      currentListingElement = currentElement.closest('.tab-pane.active').length
        ? currentElement.closest('.tab-pane.active').find(".data-listing")
        : jQuery(".data-listing");
    } else {
      currentElement = jQuery(".tab-pane.active #css_prefix_post_load_more");
      currentElement = currentElement.length ? currentElement : jQuery("#css_prefix_post_load_more");

      if (currentElement.length > 0) {
        currentListingElement = currentElement.closest('.tab-pane.active').length
          ? currentElement.closest('.tab-pane.active').find(".data-listing")
          : jQuery(".data-listing");

        currentElement.text(currentElement.data("loading-text")); 
      } else {
        console.warn("WARNING: Load More process aborted: No valid pagination element identified to initiate loadMore.");
        this.isFetching = false;
        return;
      }
    }

    const totalPages = currentElement.data("total-pages");
    const postType = currentElement.data("post-type");
    let currentPage = currentElement.data("current-page");
    const perPage = currentElement.data("per-page");
    const postId = currentElement.data("post-id");
    const extraSettings = currentElement.data("extra-settings");

    if (currentPage >= totalPages) {
      this.noMorePages(currentElement);
      this.isFetching = false;
      return;
    }

    currentPage += 1;

    const data = {
      current_page: currentPage,
      post_type: postType,
      per_page: perPage,
      post_id: postId,
      extra_setting: extraSettings,
    };

    this.fetchData(data, currentElement, currentListingElement);
  }

  /**
   * Handle the case when there are no more pages to load.
   * Removes the target pagination element (button or loader).
   * @param {jQuery} element - The specific button or loader element to hide/remove.
   */
  noMorePages(element) {
    if (element?.length) {
      if (element.attr('id') === 'css_prefix_post_load_more') {
        element.remove();
      } else if (element.attr('id') === 'css_prefix_loader-wheel-container') {
        element.remove();
        if (jQuery("#css_prefix_loader-wheel-container").length === 0 && jQuery(".tab-pane #css_prefix_loader-wheel-container").length === 0) {
          jQuery(window).off("scroll", this.handleScroll.bind(this));
        }
      }
    } else {
      console.warn('WARNING: Attempted to call noMorePages with an invalid element.');
    }
  }

  /**
   * Fetch data using AJAX.
   * @param {Object} data - The data to send in the request.
   * @param {jQuery} currentElement - The button/loader element that initiated the fetch.
   * @param {jQuery} currentListingElement - The container where new content should be appended.
   */
  fetchData(data, currentElement, currentListingElement) {
    get("st_load_more_content", {
      data: data,
      _ajax_nonce: window.stAjax,
    })
      .then((res) => {
        if (res.status) {
          this.appendContent(res.result, currentListingElement); 
          currentElement.data("current-page", data.current_page); 
          this.updatePaginationState(currentElement, data.current_page, currentElement.data("total-pages")); 
        } else {
          this.noMorePages(currentElement);
        }
        this.isFetching = false; 
      })
      .catch((error) => {
        console.error('ERROR: AJAX error during fetch:', error); 
        this.isFetching = false; 
        if (currentElement.attr('id') === 'css_prefix_post_load_more') {
          currentElement.text(currentElement.data("original-text"));
        } else if (currentElement.attr('id') === 'css_prefix_loader-wheel-container') {
          currentElement.css("display", "none");
        }
      });
  }

  /**
   * Update the state of the pagination element (button or loader).
   * @param {jQuery} element - The specific button or loader element.
   * @param {number} currentPage - The new current page number.
   * @param {number} totalPages - The total number of pages.
   */
  updatePaginationState(element, currentPage, totalPages) {
    if (currentPage >= totalPages) {
      this.noMorePages(element); 
    } else if (element.attr('id') === 'css_prefix_post_load_more') {
      element.text(element.data("original-text")); 
    } else if (element.attr('id') === 'css_prefix_loader-wheel-container') {
      element.css("display", "none"); 
    }
  }

  /**
   * Append new content to the listing.
   * @param {string} content - The new content (HTML string) to append.
   * @param {jQuery} targetListingElement - The specific jQuery object of the container where new content should be appended.
   */
  appendContent(content, targetListingElement) {
    targetListingElement?.length
      ? targetListingElement.append(content)
      : console.warn('WARNING: Target listing element not found.');
  }

}